import {createSlice} from "@reduxjs/toolkit";
import {ResponseApi} from '../BaseApi';
import {CreateMealTime, GetMealTimeById, UpdateMealTime} from './MealTimeApi';

const MealTimeSlice = createSlice({
    name: "mealTime",
    initialState: {
        addEdit: null,
        mealById: null,
    },
    reducers: {
        resetAddEdit: (state, action) => {
            state.addEdit = null;
        },
        resetMealById: (state, action) => {
            state.mealById = null;
        }
    },
    extraReducers: (builder) => {
        builder.
        addCase(UpdateMealTime.fulfilled, (state, {payload}) =>{
            state.addEdit = ResponseApi(payload);
        }).addCase(CreateMealTime.fulfilled, (state, {payload}) =>{
            state.addEdit = ResponseApi(payload);
        }).addCase(GetMealTimeById.fulfilled, (state, {payload}) =>{
            state.mealById = ResponseApi(payload);
        })
    }

})

export const { resetAddEdit, resetMealById } = MealTimeSlice.actions;

export default MealTimeSlice.reducer;
